import client from "./client";

const getGameById = (gameId: number) => client.post("/getGameById", {gameId});

const apiGame = {
    getGameById,
};

export default apiGame;
